var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Icons_Seeds",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.4 47.3C48.2 47.3 48.1 47.4 48 47.5 45.6 49.3 43.4 51.2 41.3 53.2 40.4 54 39.7 54.8 39 55.6 38.2 54.1 37.8 52.5 37.8 50.9 37.7 48.3 38.7 45.9 40.5 44 42.3 42.1 44.7 41.1 47.3 41 52.3 41.1 60.1 38.9 60.1 38.9 60.1 47.6 59.2 55.3 51.9 59.5 50.5 60.4 48.9 60.8 47.2 60.8 44.9 60.8 42.7 60 41 58.4 39.2 60.4 38 62.1 38 62.9L36 62.9C36 61.7 37 60 38.5 58.1 38.7 57.9 39 57.5 39 57.5L49 48C49 47.8 48.9 47.6 48.8 47.5 48.7 47.4 48.6 47.3 48.4 47.3ZM72.6 78.8 69.2 74.5C70.2 71.8 72 64.6 72 48.9 72 40.2 71.5 31.5 70.5 22.9L25.5 22.9C24.5 31.5 24 40.2 24 48.9 24 64.1 25.9 71.6 26.9 74.5L23.4 78.8C22.9 79.4 22.8 80.3 23.3 81 23.7 81.7 24.5 82.1 25.3 81.9 32.7 79.9 40.4 78.9 48.1 78.9 55.8 78.9 63.4 79.9 70.8 81.9 71.6 82 72.4 81.7 72.8 81 73.1 80.3 73.1 79.4 72.6 78.8L72.6 78.8Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2 16.1C69.1 15.5 68.7 15 68.1 14.8 67.5 14.6 67 14.5 66.4 14.8L64 15.9 60.9 14.3C60.3 14 59.7 14 59.1 14.3L56 15.9 52.9 14.3C52.3 14 51.7 14 51.1 14.3L48 15.9 44.9 14.3C44.3 14 43.7 14 43.1 14.3L40 15.9 36.9 14.3C36.3 14 35.7 14 35.1 14.3L32 15.9 29.6 14.8C29.1 14.6 28.4 14.6 27.9 14.8 27.4 15.1 27 15.5 26.8 16.1 26.6 17 26.3 18.3 26 19.8L70 19.8C69.7 18.3 69.4 17.1 69.2 16.1Z",
    fill: "#FFFFFF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.e1176e48acdbc952bb7a72d2497c4dcb.svg";
export { ForwardRef as ReactComponent };